import React from "react";
import { useTranslation } from "react-i18next";

import CustomInput from "../../shared/custom-components/customInput";
import StepButtons from "./stepButtons";
import useForm from "../../hooks/useForm";

const SignersForm = ({
  initialState = {},
  nextStep,
  previousStep,
  reviewMode,
}) => {
  const { handleChange, errors, onSubmit, values } = useForm({
    callback: nextStep,
    initialState,
    validation: {
      signer0: { required: true },
      identification0: { required: true },
    },
  });

  const { t } = useTranslation();

  return (
    <div className="w-100">
      <h3 className="form-title">{t(`${baseName}title`)}</h3>
      {items.map((item) => {
        const signer = `signer${item}`;
        const id = `identification${item}`;
        return (
          <div className="d-flex justify-content-between flex-wrap" key={item}>
            <div className="width-column">
              <CustomInput
                name={signer}
                placeholder={t(`${baseName}namePlaceholder`)}
                value={values[signer]}
                onChange={handleChange}
                disabled={reviewMode}
                error={errors[signer]}
                className="input-new-provider-fix"
              />
            </div>
            <div className="width-column">
              <CustomInput
                name={id}
                placeholder={t(`${baseName}identificationPlaceholder`)}
                value={values[id]}
                onChange={handleChange}
                disabled={reviewMode}
                error={errors[id]}
                className="input-new-provider-fix"
              />
            </div>
          </div>
        );
      })}
      {!reviewMode && (
        <StepButtons nextStep={onSubmit} previousStep={previousStep} />
      )}
    </div>
  );
};

export default SignersForm;

const baseName = "registerProvider.forms.signers.";
const items = [0, 1, 2];
